(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8133],{

/***/ 4104:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/informacoes/certificacoes",
      function () {
        return __webpack_require__(1319);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 1319:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ certificacoes; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./pages/src/components/Helper/Manutencao/Manutencao.js + 1 modules
var Manutencao = __webpack_require__(4151);
// EXTERNAL MODULE: ./pages/src/components/Header/Header.js + 7 modules
var Header = __webpack_require__(7331);
// EXTERNAL MODULE: ./pages/src/components/Footer/Footer.js + 5 modules
var Footer = __webpack_require__(309);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./pages/src/components/Title/Title.js
var Title = __webpack_require__(2186);
// EXTERNAL MODULE: ./pages/informacoes/certificacoes/Certificacoes.module.css
var Certificacoes_module = __webpack_require__(7151);
var Certificacoes_module_default = /*#__PURE__*/__webpack_require__.n(Certificacoes_module);
;// CONCATENATED MODULE: ./pages/src/assets/certificacoes/certIso.jpg
/* harmony default export */ var certIso = ({"src":"/_next/static/media/certIso.964c931c.jpg","height":138,"width":208,"blurDataURL":"data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAoKCgoKCgsMDAsPEA4QDxYUExMUFiIYGhgaGCIzICUgICUgMy03LCksNy1RQDg4QFFeT0pPXnFlZXGPiI+7u/sBCgoKCgoKCwwMCw8QDhAPFhQTExQWIhgaGBoYIjMgJSAgJSAzLTcsKSw3LVFAODhAUV5PSk9ecWVlcY+Ij7u7+//CABEIAAUACAMBIgACEQEDEQH/xAAoAAEBAAAAAAAAAAAAAAAAAAAABwEBAQAAAAAAAAAAAAAAAAAAAAH/2gAMAwEAAhADEAAAAKqK/8QAHBAAAgAHAAAAAAAAAAAAAAAAAQIABBETJHHi/9oACAEBAAE/AHlHZRkuDcp1sR//xAAVEQEBAAAAAAAAAAAAAAAAAAAAEf/aAAgBAgEBPwCv/8QAFBEBAAAAAAAAAAAAAAAAAAAAAP/aAAgBAwEBPwB//9k=","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./pages/src/assets/certificacoes/certFsc.jpg
/* harmony default export */ var certFsc = ({"src":"/_next/static/media/certFsc.e8bd056c.jpg","height":217,"width":242,"blurDataURL":"data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAoKCgoKCgsMDAsPEA4QDxYUExMUFiIYGhgaGCIzICUgICUgMy03LCksNy1RQDg4QFFeT0pPXnFlZXGPiI+7u/sBCgoKCgoKCwwMCw8QDhAPFhQTExQWIhgaGBoYIjMgJSAgJSAzLTcsKSw3LVFAODhAUV5PSk9ecWVlcY+Ij7u7+//CABEIAAcACAMBIgACEQEDEQH/xAAoAAEBAAAAAAAAAAAAAAAAAAAABwEBAQAAAAAAAAAAAAAAAAAAAAH/2gAMAwEAAhADEAAAAK6E/8QAFxABAAMAAAAAAAAAAAAAAAAAEQAUIf/aAAgBAQABPwDLQz//xAAUEQEAAAAAAAAAAAAAAAAAAAAA/9oACAECAQE/AH//xAAUEQEAAAAAAAAAAAAAAAAAAAAA/9oACAEDAQE/AH//2Q==","blurWidth":8,"blurHeight":7});
// EXTERNAL MODULE: ./node_modules/next/future/image.js
var future_image = __webpack_require__(1608);
var image_default = /*#__PURE__*/__webpack_require__.n(future_image);
;// CONCATENATED MODULE: ./pages/informacoes/certificacoes/index.js











var Certificacoes = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "keywords",
                        content: "Salinas, salinas, salinas embalagem, cartonagem, embalagem, cartonagem salinas, empresa Salinas, embalagem personalizada, embalagem papelao, salinas pederneiras, salinas sp"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        httpEquiv: "Cache-Control",
                        content: "max-age=604800"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: "Salinas embalagem"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "title",
                        content: "Certifica\xe7\xf5es | Cartonagem Salinas"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "Certifica\xe7\xf5es | Cartonagem Salinas"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "copyright",
                        content: "\xa9 2022 Salinas Embalagem"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header["default"], {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Title["default"], {
                title: "Certifica\xe7\xf5es"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: (Certificacoes_module_default()).certificacoes,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: " container-main",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (Certificacoes_module_default()).content,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (Certificacoes_module_default()).imgGroup,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: certIso,
                                                width: 242,
                                                height: 217,
                                                alt: "iso"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                    children: [
                                                        "As normas da ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                            children: "ISO 9001:2015"
                                                        }),
                                                        " foram elaboradas por meio de um consenso internacional acerca das pr\xe1ticas que uma empresa deve tomar a fim de atender plenamente os requisitos de qualidade. A Salinas Embalagem possui certifica\xe7\xe3o ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                            children: "ISO 9001"
                                                        }),
                                                        " , o que garante a qualidade de nossos processos, pois realizamos o monitoramento de desempenho atrav\xe9s de auditorias internas e externas peri\xf3dicas."
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                    children: [
                                                        " ",
                                                        "Para manter a certifica\xe7\xe3o, diversos requisitos devem ser atendidos. Podendo destacar: A padroniza\xe7\xe3o, o monitoramento da mat\xe9ria prima, realiza\xe7\xe3o de pesquisas peri\xf3dicas com os clientes, rastreabilidade de toda cadeia produtiva, e um cronograma de treinamento para garantir a qualifica\xe7\xe3o e o desempenho de nossos colaboradores."
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                    children: [
                                                        "A",
                                                        " ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                            children: "IQNet (The International Certification Network)"
                                                        }),
                                                        " ",
                                                        "foi criada em 1990. Sediada na Su\xed\xe7a, \xe9 uma rede internacional de entidades certificadoras. Com o certificado IQNet a Salinas Embalagem obt\xe9m reconhecimento e valoriza\xe7\xe3o no mercado internacional."
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (Certificacoes_module_default()).content,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: certFsc,
                                                width: 208,
                                                height: 138,
                                                alt: "fsc"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                    children: [
                                                        "A ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                            children: "Forest Stewardship Council \xae( FSC\xae)"
                                                        }),
                                                        " \xe9 uma organiza\xe7\xe3o n\xe3o governamental e sem fins lucrativos que tem a miss\xe3o de promover o manejo respons\xe1vel das florestas do mundo. A Salinas Embalagem \xe9 certificada com o selo FSC\xaecadeia de cust\xf3dia (COC), ou seja, adquire sua mat\xe9ria-prima de produtores que processam a mat\xe9ria-prima de florestas certificadas, garantindo a rastreabilidade de toda a cadeia produtiva. A Salinas Embalagem declara que n\xe3o est\xe1 direta ou indiretamente envolvida nas seguintes atividades: Dentro dos itens citados abaixo da frase acima:"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "Corte de madeira ilegal ou com\xe9rcio ilegal de produtos florestais ou madeireiros;"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "Viola\xe7\xe3o de direitos tradicionais e humanos em opera\xe7\xf5es florestais;"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "Destrui\xe7\xe3o de atributos de alto valor para conserva\xe7\xe3o em opera\xe7\xf5es florestais;"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "Convers\xe3o significativa de florestas em planta\xe7\xf5es ou uso n\xe3o florestal;"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "Introdu\xe7\xe3o de organismos geneticamente modificados em opera\xe7\xf5es florestais;"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                            children: [
                                                                " ",
                                                                "Viola\xe7\xe3o de qualquer uma das Conven\xe7\xf5es da OIT (ILO Core Conventions) conforme definido na Declara\xe7\xe3o da OIT sobre Princ\xedpios e Direitos Fundamentais no Trabalho, 1998."
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer["default"], {})
        ]
    });
};
/* harmony default export */ var certificacoes = (Certificacoes);


/***/ }),

/***/ 4151:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Manutencao_Manutencao; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./pages/src/components/Helper/Manutencao/Manutencao.module.css
var Manutencao_module = __webpack_require__(8054);
var Manutencao_module_default = /*#__PURE__*/__webpack_require__.n(Manutencao_module);
;// CONCATENATED MODULE: ./pages/src/assets/manutencao/gear.svg
/* harmony default export */ var gear = ({"src":"/_next/static/media/gear.c5b74b93.svg","height":512,"width":512});
// EXTERNAL MODULE: ./node_modules/next/future/image.js
var future_image = __webpack_require__(1608);
var image_default = /*#__PURE__*/__webpack_require__.n(future_image);
;// CONCATENATED MODULE: ./pages/src/components/Helper/Manutencao/Manutencao.js





var Manutencao = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
            className: (Manutencao_module_default()).manutencao,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    children: "P\xe1gina em Manuten\xe7\xe3o..."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: gear.src,
                        height: 100,
                        width: 100,
                        alt: "engrenagem"
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var Manutencao_Manutencao = (Manutencao);


/***/ }),

/***/ 2186:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _Title_module_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6696);
/* harmony import */ var _Title_module_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_Title_module_css__WEBPACK_IMPORTED_MODULE_2__);



var Title = function(param) {
    var title = param.title, children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: " container-main ",
        children: children ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h1", {
            className: (_Title_module_css__WEBPACK_IMPORTED_MODULE_2___default().title),
            children: [
                children,
                title
            ]
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
            className: (_Title_module_css__WEBPACK_IMPORTED_MODULE_2___default().title),
            children: title
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Title);


/***/ }),

/***/ 7151:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"certificacoes":"Certificacoes_certificacoes__JEFD_","content":"Certificacoes_content__CZv75"};

/***/ }),

/***/ 8054:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"manutencao":"Manutencao_manutencao__qJjoq","spiner":"Manutencao_spiner__clLQZ"};

/***/ }),

/***/ 6696:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"title":"Title_title__DeTTb"};

/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(5443)


/***/ }),

/***/ 1163:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(387)


/***/ }),

/***/ 603:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _slicedToArray; }
});

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_array_with_holes.mjs
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_iterable_to_array.mjs
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_non_iterable_rest.mjs
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_array_like_to_array.mjs
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_unsupported_iterable_to_array.mjs


function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray(o, minLen);
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs





function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArray(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1608,1664,640,9774,2888,179], function() { return __webpack_exec__(4104); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);